import axios from 'axios'

export default {
  state: {
    authenticated: false,
    code: null,
    token: null,
    refresh_token: null
  },
  getters: {
    id_token: state => {
      return state.token.id_token
    },
    idTokenData: state => {
      if (state.token.id_token) {
        return JSON.parse(atob(state.token.id_token.split('.')[1]))
      }
    },
    authenticated: state => {
      return state.authenticated
    }
  },
  mutations: {
    LOGOUT (state) {
      state.token = null
      state.refresh_token = null
      state.authenticated = false
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      window.location.replace("https://" + window.authEndpoint + "/logout?client_id=" + window.cognitoAppClientId + "&logout_uri=https://" + window.redirectUri)
    },
    SET_TOKEN (state, token) {
      state.token = token
      state.authenticated = true
      localStorage.setItem('token', JSON.stringify(token))
    },
    SET_REFRESH_TOKEN (state, refreshToken) {
      state.refresh_token = refreshToken
      localStorage.setItem('refresh_token', JSON.stringify(refreshToken))
    }
  },
  actions: {
    LOGOUT ({ commit }) {
      commit('LOGOUT')
    },
    SET_TOKEN ({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    SET_REFRESH_TOKEN ({ commit }, refreshToken) {
      commit('SET_REFRESH_TOKEN', refreshToken)
    },
    GET_TOKENS ({ commit }, code) {
      console.log('GET_TOKENS action')
      console.log(code)
      var headers = {}
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
      if (typeof code !== 'undefined') {
        console.log(this)
        axios.post(
          'https://' + window.authEndpoint + '/oauth2/token',
          'grant_type=authorization_code&client_id=' + window.cognitoAppClientId +
          '&redirect_uri=https://' + window.redirectUri +
          '&code=' + code,
          { headers: headers })
          .then(response => {
            console.log(response)
            if (response.data) {
              commit('SET_TOKEN', response.data)
              commit('SET_REFRESH_TOKEN', response.data.refresh_token)
            }
          })
      }
    }
  }
}